import React from 'react';
import styles from './StudentDetailsCell.module.css';
import MLIcon from '../MLIcon';
import MLTooltip from '../MLTooltip';
import { useDisableEscapeKeyDown } from '../../hooks/useDisableEscapeKeyDown';
import clsx from 'clsx';

const copyToClipboard = (str, event) => {
  event.stopPropagation();
  navigator.clipboard.writeText(str);
};

const StudentDetailsCell = ({
  studentId,
  firstName,
  lastName,
  email,
  showWarning,
  handleISGLaunch,
  setOpen,
  nameTestId,
}) => {
  const {
    enableEscapeKeyDown,
    disableEscapeKeyDownHandler,
  } = useDisableEscapeKeyDown();

  const handleNameClick = () => {
    handleISGLaunch(studentId);
    setOpen(false);
  };

  return (
    <td className={styles.studentDetails} tabIndex={0}>
      <MLIcon
        type="warning"
        testId="warning-icon"
        className={clsx(styles.warningIcon, {
          [styles.hideWarningIcon]: !showWarning,
        })}
      />
      <div>
        <button
          className={styles.studentName}
          onClick={handleNameClick}
          data-test-id={nameTestId}
        >
          {firstName}{' '}
          <span className={styles.studentLastName}>{lastName}</span>
        </button>
        {email && (
          <MLTooltip
            interactive={true}
            onOpen={disableEscapeKeyDownHandler}
            onClose={enableEscapeKeyDown}
            content={
              <div className={styles.copyEmailTooltip}>
                <button
                  className={styles.copyEmailButton}
                  onClick={(event) => copyToClipboard(email, event)}
                >
                  Copy email to clipboard
                </button>
              </div>
            }
          >
            <div className={styles.studentEmail}>{email}</div>
          </MLTooltip>
        )}
      </div>
    </td>
  );
};

export default StudentDetailsCell;
